import React from 'react'
import {
  TextInput,
  SimpleForm,
  required,
  Create,
  useNotify,
  useRedirect,
  SelectInput,
} from 'react-admin'

import { Grid, Paper, Typography, makeStyles } from '@material-ui/core'

import { Tooltip, ColorPicker } from 'components'

const useStyles = makeStyles({
  container: {
    width: '100%',
  },
  gridContainer: {
    width: '100%',
  },
  formContainer: {
    backgroundColor: '#F5F5F5',
  },
  paperContainer: {
    padding: 16,
  },
})

export const CreateForm = (props: any) => {
  const redirect = useRedirect()
  const notify = useNotify()
  const classes = useStyles()
  const {
    shouldRedirect = true,
    onSubmitSuccess = () => {},
    onSubmitFailure = () => {},
    toolbar = <></>,
    aside = <></>,
    ...rest
  } = props

  const onSuccess = () => {
    notify('post_successfully')
    if (shouldRedirect) redirect(props.basePath)
    onSubmitSuccess()
  }

  const onFailure = (error: any) => {
    onSubmitFailure(error)
    notify('post_failed', 'warning')
  }

  return (
    <Create
      aside={aside}
      {...rest}
      onSuccess={onSuccess}
      onFailure={onFailure}
      className={classes.container}
    >
      <SimpleForm
        warnWhenUnsavedChanges
        className={classes.formContainer}
        toolbar={toolbar}
        initialValues={{
          act: true,
          color: '#ffffff',
        }}
      >
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          spacing={2}
          className={classes.gridContainer}
        >
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Paper className={classes.paperContainer}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography variant="h5" color="textSecondary" gutterBottom>
                  Inserir Novo Marcador
                </Typography>
                <hr />
              </Grid>

              <Grid
                container
                spacing={2}
                className={classes.gridContainer}
                direction="column"
              >
                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                  <Tooltip title={'marks.type'}>
                    <SelectInput
                      fullWidth
                      label="Tipo"
                      source="type"
                      choices={[
                        { id: 'contained', name: 'Opaco - contained' },
                        { id: 'outlined', name: 'Borda - outlined' },
                      ]}
                      validate={[required('Obrigatório')]}
                      externalLoading={false}
                    />
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                  <Tooltip title={'marks.text'}>
                    <TextInput
                      fullWidth
                      label="Conteúdo"
                      source="text"
                      validate={[required('Obrigatório')]}
                    />
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                  <Tooltip title={'marks.text_color'}>
                    <ColorPicker
                      fullWidth
                      label="Cor do texto"
                      source="text_color"
                      validate={[required('Obrigatório')]}
                      readOnly
                    />
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                  <Tooltip title={'marks.default_color'}>
                    <ColorPicker
                      fullWidth
                      label="Cor padrão"
                      source="default_color"
                      validate={[required('Obrigatório')]}
                      readOnly
                    />
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                  <Tooltip title={'marks.direction'}>
                    <SelectInput
                      fullWidth
                      label="Posição"
                      source="direction_text"
                      choices={[
                        { id: 'left', name: 'Esquerda' },
                        { id: 'right', name: 'Direita' },
                      ]}
                      validate={[required('Obrigatório')]}
                      externalLoading={false}
                    />
                  </Tooltip>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  )
}
